import { useRoleCheck } from "./use-role-check";

/**
 * @deprecated Use useRoleCheck() instead for enhanced RBAC support
 * This hook is kept for backward compatibility
 */
export function useAdvisorCheck() {
  const { data: roleData, isLoading } = useRoleCheck();
  
  return {
    data: {
      isAdvisor: roleData?.isAdvisor || false,
      isLoading
    },
    isLoading
  };
}
